import { useState } from "react";
import { ArrowRight, Funnel } from "@phosphor-icons/react";
import { money, fmtDate } from "@/lib/api";
import { usePipeline } from "@/components/integrations/PipelineCard";

const SHOW = 5;
const shift = (d) => { const a = Math.abs(d); return a >= 45 ? `${(a / 30.44).toFixed(1)} mo` : `${a} days`; };

const RunwayShift = ({ before, after }) => {
  if (!before && !after) return null;
  const b = before?.zero_cash_date, a = after?.zero_cash_date;
  const delta = before?.runway_months != null && after?.runway_months != null ? after.runway_months - before.runway_months : null;
  const tone = delta == null ? "text-[#A3A3A3]" : delta < 0 ? "text-[#FF5C7A]" : delta > 0 ? "text-[#00FF9D]" : "text-[#A3A3A3]";
  return (
    <p data-testid="deal-slips-runway" className="mt-2 text-sm text-[#A3A3A3]">
      Runway incl. pipeline: <span className="font-mono text-white">{b ? fmtDate(b) : "not in 24 mo"}</span>
      <ArrowRight size={12} className="inline mx-1.5" /><span className="font-mono text-white">{a ? fmtDate(a) : "not in 24 mo"}</span>
      {delta != null && delta !== 0 && <span className={`ml-2 font-mono ${tone}`}>{delta > 0 ? "+" : ""}{delta.toFixed(1)} mo</span>}
      {delta === 0 && b === a && <span data-testid="deal-slips-no-shift" className="ml-2 text-xs">(no change: these deals land after your current zero-cash date)</span>}
    </p>
  );
};

export const DealSlips = () => {
  const { data } = usePipeline();
  const [all, setAll] = useState(false);
  const c = data?.changes;
  if (!data?.connected || !c) return null;
  const rows = all ? c.moved : c.moved.slice(0, SHOW);
  return (
    <div data-testid="deal-slips" className="rounded-xl border border-[#FF7AC6]/30 bg-[#121212] p-6">
      <p className="font-mono text-xs text-[#FF9FD6] flex items-center gap-2"><Funnel /> PIPELINE CHANGES SINCE {fmtDate(c.compared_to).toUpperCase()}</p>
      <RunwayShift before={c.before} after={c.after} />
      {c.moved.length === 0 ? (
        <p data-testid="deal-slips-none" className="mt-3 text-sm text-[#A3A3A3]">No deal moved its close date by a week or more.</p>
      ) : (
        <div className="mt-4 divide-y divide-[#2A2A2A]">
          {rows.map((m, i) => (
            <div key={m.name} data-testid={`deal-slip-${i}`} className="flex items-center gap-3 py-2.5 text-sm">
              <div className="flex-1 min-w-0">
                <p className="truncate">{m.name}</p>
                <p className="font-mono text-[11px] text-[#6B6B6B]">{money(m.amount, true)} · {m.stage} · likely {money(m.weighted, true)}</p>
              </div>
              <p className="font-mono text-xs text-[#A3A3A3] whitespace-nowrap">{fmtDate(m.from)} <ArrowRight size={10} className="inline" /> {fmtDate(m.to)}</p>
              <span className={`w-36 shrink-0 text-right font-mono text-xs whitespace-nowrap ${m.days > 0 ? "text-[#FF5C7A]" : "text-[#00FF9D]"}`}>{m.days > 0 ? "slipped" : "pulled in"} {shift(m.days)}</span>
            </div>
          ))}
        </div>
      )}
      <div className="mt-3 flex flex-wrap items-center gap-4 text-[11px] text-[#6B6B6B]">
        {c.added > 0 && <span data-testid="deal-slips-added">{c.added} new {c.added === 1 ? "deal" : "deals"}</span>}
        {c.removed > 0 && <span data-testid="deal-slips-removed">{c.removed} no longer in the file (won, lost or removed)</span>}
        {c.moved.length > SHOW && (
          <button data-testid="deal-slips-toggle" onClick={() => setAll((v) => !v)} className="text-[#FF9FD6] hover:underline">
            {all ? "Show fewer" : `Show all ${c.moved.length} moved deals`}
          </button>
        )}
      </div>
    </div>
  );
};
